import React, { useEffect, useState } from "react";
import { Routes, Route, Link } from "react-router-dom";
import { useAppState } from "../contexts/AppContext";
import Login from "./login";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import Clients from "../pages/Clients";
import Invoices from "../pages/Invoices";
import Auth, { checkAuth, logout, me } from "../helpers/Auth";
import ClientCreate from "../pages/ClientCreate";
import InvoiceCreate from "../pages/InvoiceCreate";
import Vendors from "../pages/Vendors";
import Users from "../pages/Users";
import UserCreate from "../pages/UserCreate";
import Dashboard from "../pages/Dashboard";
import Invoice from "../pages/Invoice";

dayjs.extend(localizedFormat)



export default function App() {
    const { appState, setAppState } = useAppState()

    useEffect(() => {
        Auth.me().then((data) => {
            setAppState({
                user: {
                    name: data.user.name,
                    email: data.user.email,
                }
            })
        })
    }, [])

    useEffect(() => {
        console.log(appState.user)
    }, [appState.user])

    if (!checkAuth()) {
        return <Login />
    }

    return (
        <>
            <header className="w-full">
                <nav className="container mx-auto px-4 sm:px-6 lg:px-8 py-10 flex items-center justify-between">
                    <ul>
                        <li>
                            <Link className="text-lg font-medium" to="/">Billing</Link>
                        </li>
                    </ul>
                    <ul className="flex space-x-9">
                        {appState.user?.email === 'bovatitar@gmail.com' ? (<li>
                            <Link to="/vendors">Vendors</Link>
                        </li>) : null}
                        <li>
                            <Link to="/users">Users</Link>
                        </li>
                        <li>
                            <Link to="/clients">Clients</Link>
                        </li>
                        <li>
                            <Link to="/invoices">Invoices</Link>
                        </li>
                        <li>
                            <a href="#" onClick={logout}>Logout ({appState.user.email})</a>
                        </li>
                    </ul>
                </nav>
            </header>
            <div className="container w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col">
                <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/clients" element={<Clients />} />
                    <Route path="/clients/create" element={<ClientCreate />} />
                    <Route path="/invoices" element={<Invoices />} />
                    <Route path="/invoices/create" element={<InvoiceCreate />} />
                    <Route path="/invoices/:id" element={<Invoice />} />
                    {appState.user?.email === 'bovatitar@gmail.com' ? (
                        <Route path="/vendors" element={<Vendors />} />
                    ) : null}
                    <Route path="/users" element={<Users />} />
                    <Route path="/users/create" element={<UserCreate />} />
                </Routes>
            </div>
        </>
    )
}
